import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Placeholder, Mask, QRCodeLayout, Spin, SpinText } from './styled';
// import LoadingIcon from '../../asset/loading.svg';
export type QRCodeStatus = 'normal' | 'error' | 'loading';

export interface QRCodeProps {
  // orderId: string;
  value?: string;
  /**
   * L: LOW
   * M: MEDIUM
   * Q: QUARTILE
   * H: HIGH
   */
  level?: 'L' | 'M' | 'Q' | 'H';
  size?: number;
  includeMargin?: boolean;
  status?: QRCodeStatus;
  error?: React.ReactElement;
}

function QRCode(props: QRCodeProps) {
  const {
    value,
    status = 'normal',
    includeMargin,
    size = 128,
    error = false,
  } = props;

  // const {reset} = useCheck(() => {
  //   Http.get(`/checkout/orders/${orderId}`)
  // }, {
  //   enabled: true
  // });

  return (
    <QRCodeLayout size={size}>
      {value ? (
        <QRCodeSVG
          includeMargin={includeMargin}
          style={{ verticalAlign: 'middle' }}
          value={value}
          size={size}
        />
      ) : null}
      {status === 'loading' ? (
        <>
          <Placeholder>
            <Spin />
            <SpinText>Loading...</SpinText>
          </Placeholder>
          <Mask />
        </>
      ) : null}
      {status === 'error' ? (
        <>
          <Placeholder>{error}</Placeholder>
          <Mask />
        </>
      ) : null}
    </QRCodeLayout>
  );
}

export default QRCode;
